import { isEmpty } from "ramda";
import { DataProviderKey, IGetListParams } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { UserRole } from "../../../types/user.types";
import { getFinalList } from "../../../utils/collectionQuery";
import { firestore } from "../../firebase";

const coachsReservationsResource = {
  [AppResource.coachReservations]: {
    [DataProviderKey.getList]: async (params: IGetListParams) => {
      const isCoach = params.user.role === UserRole.coach;
      let enhancedFilter = isCoach
        ? {
            filter: {
              coachId: params.user.id,
            },
            operators: {},
          }
        : {
            filter: {},
            operators: {},
          };

      return getFinalList(
        {
          ...params,
          limit: params.pagination.perPage,
          filter: {
            ...params.filter,
            ...enhancedFilter.filter,
            status:
              !isEmpty(params.filter) && params.filter.status ? [params.filter.status] : ["confirmed", "canceled"],
          },
          operators: {
            ...params.operators,
            ...enhancedFilter.operators,
            status: "in",
          },
        },
        firestore.collection(AppResource.coachReservations)
      );
    },
  },
};

export default coachsReservationsResource;
